import MemberRequest from "../../../../Controllers/MemberRequest";

function getResult(data) {
  let res=false;
  if (data.hasOwnProperty("moshkelatInsert")) {
    res = data.moshkelatInsert;
  }
  return res;
}

const sendInsertApi = async function (title, ostanId,shahrestanId,tell,address,description,rahkar,filesTmpId, pageAlerts,formAlerts) {
  let res=false;
  let req=new MemberRequest();
  req._formAlerts=formAlerts;
  req._pageAlerts=pageAlerts;

  if(!Boolean(ostanId)) ostanId=0;
  if(!Boolean(shahrestanId)) shahrestanId=0;

  req.query=`{moshkelatInsert(title:"${title}",tell:"${tell}",address:"${address}",ostanId:${ostanId},shahrestanId:${shahrestanId}, 
  filesTmpId:[${filesTmpId.toString()}],description:"""${description}""",rahkar:"""${rahkar}""")}`;
  res = await req.send(getResult);
  return res;
};

export default async function moshkelatInsertApi( title, ostanId,shahrestanId,tell,address,description,rahkar,filesTmpId, pageAlerts,formAlerts) {
  return await sendInsertApi(title, ostanId,shahrestanId,tell,address,description,rahkar,filesTmpId , pageAlerts,formAlerts);
}
